import { CmsLayoutType, LayoutWidthType } from '../../CmsComponents.interfaces';

const browserWidthLayouts: CmsLayoutType[] = [
  'Carousel',
  'LayoutExtraLargeBanner1',
  'LayoutExtraLargeBanner2',
  'PromotionsGallery',
];

export const resolveDefaultWithdType = (layout: CmsLayoutType): LayoutWidthType =>
  browserWidthLayouts.includes(layout) ? LayoutWidthType.browserWidth : LayoutWidthType.contentWidth;
